import { render } from "./DetallePronunciamientoOperacion.vue?vue&type=template&id=85b07200&scoped=true"
import script from "./DetallePronunciamientoOperacion.vue?vue&type=script&lang=js"
export * from "./DetallePronunciamientoOperacion.vue?vue&type=script&lang=js"

import "./DetallePronunciamientoOperacion.vue?vue&type=style&index=0&id=85b07200&scoped=true&lang=css"

import exportComponent from "C:\\AgentesAzure\\SVRAPQAHIR01\\vsts-agent-win-x64-4.261.0\\_work\\31\\s\\CCD\\hircasa-ccd-webapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85b07200"]])

export default __exports__